import { supabase } from './supabase'
import { getOrCreateProfile } from './profileService'
import { User, AuthError } from '@supabase/supabase-js'

export interface SignUpData {
  email: string
  password: string
  username?: string
}

export async function signUpUser(data: SignUpData): Promise<{ user: User | null; error: AuthError | null }> {
  console.log('🔄 Iniciando cadastro de usuário:', data.email)
  
  try {
    // Passo 1: Criar usuário no Supabase Auth
    const { data: authData, error: authError } = await supabase.auth.signUp({
      email: data.email,
      password: data.password,
      options: {
        data: {
          username: data.username || null
        }
      }
    })

    if (authError) {
      console.error('❌ Erro no cadastro Auth:', authError)
      return { user: null, error: authError }
    }

    if (!authData.user) {
      console.error('❌ Nenhum usuário retornado do Auth')
      return { user: null, error: { message: 'Falha ao criar usuário' } as AuthError }
    }

    console.log('✅ Usuário criado no Auth:', authData.user.id)

    // Passo 2: Aguardar um pouco para garantir que o usuário está no sistema
    await new Promise(resolve => setTimeout(resolve, 1000))

    // Passo 3: Criar perfil
    console.log('🔄 Criando perfil para usuário:', authData.user.id)
    
    const { data: profileData, error: profileError } = await getOrCreateProfile(
      authData.user.id,
      authData.user.email,
      data.username
    )

    if (profileError) {
      console.error('❌ Erro ao criar perfil:', profileError)
      // Não falhar o cadastro por causa do perfil
      console.log('⚠️ Continuando sem perfil, será criado no próximo login')
    } else {
      console.log('✅ Perfil criado:', profileData)
    }

    return { user: authData.user, error: null }

  } catch (error) {
    console.error('❌ Erro inesperado no cadastro:', error)
    return { user: null, error: { message: 'Erro inesperado no cadastro' } as AuthError }
  }
}

export async function signInUser(email: string, password: string): Promise<{ user: User | null; error: AuthError | null }> {
  console.log('🔄 Iniciando login:', email)
  
  try {
    const { data, error } = await supabase.auth.signInWithPassword({
      email,
      password
    })

    if (error) {
      console.error('❌ Erro no login:', error)
      return { user: null, error }
    }

    console.log('✅ Login realizado:', data.user?.id)
    return { user: data.user, error: null }

  } catch (error) {
    console.error('❌ Erro inesperado no login:', error)
    return { user: null, error: { message: 'Erro inesperado no login' } as AuthError }
  }
}
